<template>
  <v-app-bar v-bind="attrs" app flat data-cy="toolbar" :color="corToolbar" elevation="4">
    <slot name="toolbar-avatar">
      <v-avatar
        style="cursor: pointer"
        max-height="40px"
        size="85"
        class="ml-3"
        tile
      >
        <ImagemComFallback
          :src="logoSrc"
          :srcDefault="$theme.logo || '/assets/imgs/logo.svg'"
          width="100%"
          height="100%"
          contain
          data-cy="toolbar-img"
        />
      </v-avatar>
    </slot>

    <slot name="toolbar-title">
      &nbsp;
    </slot>

    <slot name="toolbar-drawer">
      &nbsp;
    </slot>

    <slot name="toolbar-before-space"></slot>

    <v-spacer></v-spacer>

    <slot name="toolbar-after-spacer"></slot>

    <slot name="toolbar-timer">
      <v-btn
        text
        tile
        class="text-subtitle-2"
      >
        06:30
        <v-icon class="pl-2" color="green">mdi-timer-outline</v-icon>
      </v-btn>
    </slot>

    <slot name="toolbar-options">
      <v-menu offset-y data-cy="toolbar-menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            tile
            class="text-subtitle-2"
            v-bind="attrs"
            v-on="on"
            data-cy="toolbar-menu-button">
            Ana Silva
            <v-icon class="pl-2" data-cy="toolbar-menu-icon">mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list dense data-cy="toolbar-list">
          <slot name="toolbar-user-options"></slot>
          <v-list-item link data-cy="toolbar-list-item-logout">
            <v-list-item-title data-cy="toolbar-list-item-logout-title">
              <v-icon small class="pr-2" color="error" data-cy="toolbar-list-item-logout-icon">mdi-exit-to-app</v-icon>
              Sair
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </slot>
  </v-app-bar>
</template>

<script>

export default {
  props: {
    logo: String,
    cor: String
  },
  data () {
    return {
      userIdentificador: ''
    }
  },
  computed: {
    attrs () {
      return { ...this.$theme.options.toolbar, ...this.$attrs }
    },
    logoSrc () {
      return this.logo;
    },
    corToolbar () {
      return this.cor;
    }
  },
  mounted () {
    const th = this
    this.userIdentificador = th.$store.getters.user.identificador
  }
}
</script>
